import React from 'react';
import { Slide, FadeIn, SlideHeading, StaggerContainer, StaggerItem, Card } from './Shared';
import { TrendingUp, Shirt, Briefcase, ShoppingBag, Store, Printer, Palette, Image as ImageIcon, Droplet, Lightbulb, GraduationCap, Code, Factory, Cpu, Globe, Zap, Check } from 'lucide-react';
export const Slide6MarketOpportunity = () => <Slide id="slide-6" bg="gray" data-id="element-227">
    <SlideHeading tag="Market Opportunity" title="A $10B+ Industry" subtitle="Capitalizing on the convergence of custom manufacturing and digital commerce." data-id="element-228" />

    <div className="grid grid-cols-1 mt-8" data-id="element-229">
      <FadeIn delay={0.1} data-id="element-230">
        <div className="border-4 border-black p-10 md:p-16 flex flex-col md:flex-row items-center justify-between bg-white" data-id="element-231">
          <div className="mb-12 md:mb-0 text-center md:text-left" data-id="element-232">
            <h3 className="text-2xl font-bold text-slate-500 uppercase tracking-widest mb-4" data-id="element-233">
              Global Custom Apparel
            </h3>
            <div className="text-8xl md:text-9xl font-serif font-bold text-black leading-none" data-id="element-234">
              $10B<span className="text-slate-400" data-id="element-235">+</span>
            </div>
          </div>
          <div className="w-full md:w-1/2 space-y-8" data-id="element-236">
            <div className="flex items-start gap-6" data-id="element-237">
              <div className="w-16 h-16 bg-black flex items-center justify-center shrink-0" data-id="element-238">
                <TrendingUp className="w-8 h-8 text-white" data-id="element-239" />
              </div>
              <div data-id="element-240">
                <h4 className="text-2xl font-serif font-bold text-black uppercase mb-2" data-id="element-241">
                  DTC & Creator Economy
                </h4>
                <p className="text-slate-600 text-lg" data-id="element-242">
                  Explosive demand for high-quality, on-demand merch from
                  creators and niche brands.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-6" data-id="element-243">
              <div className="w-16 h-16 bg-black flex items-center justify-center shrink-0" data-id="element-244">
                <Shirt className="w-8 h-8 text-white" data-id="element-245" />
              </div>
              <div data-id="element-246">
                <h4 className="text-2xl font-serif font-bold text-black uppercase mb-2" data-id="element-247">
                  Personalization Demand
                </h4>
                <p className="text-slate-600 text-lg" data-id="element-248">
                  Businesses and consumers increasingly require premium,
                  customized apparel solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </div>
  </Slide>;
export const Slide7RevenueEcosystem = () => {
  const channels = [{
    icon: Briefcase,
    title: 'B2B Custom Apparel',
    desc: 'Contractors, schools, sports teams, restaurants, uniforms, events',
    focus: true,
    tag: 'Phase 1'
  }, {
    icon: ShoppingBag,
    title: 'DTC Brands',
    desc: 'KE CHINGÓN + future niche brands, seasonal collections, premium graphic apparel',
    focus: true,
    tag: 'Phase 1'
  }, {
    icon: Store,
    title: 'Marketplace Sales',
    desc: 'Shopify, Amazon, TikTok Shop, Facebook, Instagram',
    focus: true,
    tag: 'Phase 1'
  }, {
    icon: Printer,
    title: 'Production Services',
    desc: 'DTF transfers, custom garment printing, short-run production, white label fulfillment',
    focus: false,
    tag: null
  }, {
    icon: Droplet,
    title: 'Ink Systems',
    desc: 'IT Image Technologies rep — private label inks on Amazon + retail with strong margins',
    focus: true,
    tag: 'High Margin'
  }, {
    icon: GraduationCap,
    title: 'Education Platform',
    desc: 'Workshops every 2 weeks — screen printing, DTF, color separations, ink training',
    focus: true,
    tag: 'Recurring'
  }];
  return <Slide id="slide-7" bg="white" data-id="element-249">
      <SlideHeading tag="Revenue Ecosystem" title="6 Focused Channels" subtitle="No fluff. Every channel is real, actionable, and ready to generate revenue now." data-id="element-250" />

      <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-id="element-251">
        {channels.map((channel, i) => <StaggerItem key={i} data-id="element-252">
            <Card dark={channel.focus} className={`h-full p-8 flex flex-col items-center text-center relative ${!channel.focus ? 'opacity-80' : ''}`} data-id="element-253">
              {channel.tag && <div className={`absolute -top-3 right-4 text-xs font-bold px-3 py-1 uppercase tracking-widest ${channel.focus ? 'bg-white text-black border-2 border-black' : 'bg-black text-white'}`} data-id="element-254">
                  {channel.tag}
                </div>}
              <div className={`w-14 h-14 flex items-center justify-center mb-6 ${channel.focus ? 'bg-white' : 'bg-black'}`} data-id="element-255">
                <channel.icon className={`w-7 h-7 ${channel.focus ? 'text-black' : 'text-white'}`} data-id="element-256" />
              </div>
              <h4 className={`font-serif font-bold uppercase text-xl mb-3 leading-tight ${channel.focus ? 'text-white' : 'text-black'}`} data-id="element-257">
                {channel.title}
              </h4>
              <p className={`text-sm font-medium leading-relaxed ${channel.focus ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-258">
                {channel.desc}
              </p>
            </Card>
          </StaggerItem>)}
      </StaggerContainer>

      {/* Ink + Education Revenue Math */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12" data-id="element-259">
        <FadeIn delay={0.3} data-id="element-260">
          <div className="border-4 border-black p-8 bg-white" data-id="element-261">
            <div className="flex items-center gap-4 mb-4" data-id="element-262">
              <Droplet className="w-8 h-8 text-black" data-id="element-263" />
              <h4 className="text-2xl font-serif font-bold text-black uppercase" data-id="element-264">
                Ink Systems Revenue
              </h4>
            </div>
            <p className="text-slate-600 text-lg mb-4" data-id="element-265">
              Official IT Image Technologies representation. Licensed to sell
              under our own brand on Amazon, marketplaces, and direct retail.
            </p>
            <p className="text-black font-bold text-lg" data-id="element-266">
              Strong margins • Recurring reorders • Scalable via ecommerce
            </p>
          </div>
        </FadeIn>
        <FadeIn delay={0.4} data-id="element-267">
          <div className="border-4 border-black p-8 bg-black text-white" data-id="element-268">
            <div className="flex items-center gap-4 mb-4" data-id="element-269">
              <GraduationCap className="w-8 h-8 text-white" data-id="element-270" />
              <h4 className="text-2xl font-serif font-bold text-white uppercase" data-id="element-271">
                Education Revenue
              </h4>
            </div>
            <div className="space-y-2 text-lg" data-id="element-272">
              <p className="text-slate-300" data-id="element-273">
                12 students × $400/session × 2 sessions/month
              </p>
              <p className="text-white font-serif font-bold text-4xl mt-4" data-id="element-274">
                $9,600<span className="text-xl text-slate-400" data-id="element-275">/month</span>
              </p>
              <p className="text-white font-serif font-bold text-2xl" data-id="element-276">
                $115K<span className="text-lg text-slate-400" data-id="element-277">/year</span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </Slide>;
};
export const Slide8WhyNow = () => <Slide id="slide-8" bg="gray" data-id="element-278">
    <SlideHeading tag="Why Now" title="The Perfect Storm" subtitle="Technological advancement meets operational readiness." data-id="element-279" />

    <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-280">
      {[{
      title: 'Infrastructure Built',
      desc: 'We are not starting from zero. Equipment is installed, systems are active, and production is ready to scale immediately.',
      icon: Factory
    }, {
      title: 'AI Acceleration',
      desc: 'AI tools have drastically reduced the cost and time required for marketing, content creation, and operational workflows.',
      icon: Cpu
    }, {
      title: 'Remote Team Availability',
      desc: 'High-tier global talent in Mexico and Colombia is more accessible than ever, allowing scalable operations with low overhead.',
      icon: Globe
    }, {
      title: 'Ecommerce Maturity',
      desc: 'Multi-channel selling (Shopify, TikTok Shop, Amazon) is streamlined, allowing rapid deployment of our 1000+ ready designs.',
      icon: Zap
    }].map((item, i) => <StaggerItem key={i} data-id="element-281">
          <Card className="h-full flex flex-col p-10" data-id="element-282">
            <div className="w-16 h-16 bg-black flex items-center justify-center mb-8" data-id="element-283">
              <item.icon className="w-8 h-8 text-white" data-id="element-284" />
            </div>
            <h3 className="text-3xl font-serif font-bold text-black uppercase mb-4" data-id="element-285">
              {item.title}
            </h3>
            <p className="text-slate-600 text-lg leading-relaxed flex-grow" data-id="element-286">
              {item.desc}
            </p>
          </Card>
        </StaggerItem>)}
    </StaggerContainer>
  </Slide>;
export const Slide9CompetitiveAdvantages = () => <Slide id="slide-9" bg="white" data-id="element-287">
    <SlideHeading tag="Competitive Advantages" title="Why STRATA Wins" subtitle="Unfair advantages built over decades, not months." data-id="element-288" />

    <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-id="element-289">
      {['30+ Years Real Experience', 'Already Operational', 'Immediate B2B Readiness', 'Multiple Revenue Channels', '1000+ Designs Ready Now', 'Owned Brands with Upside', 'Proprietary Ink Brand Potential', 'Active Ecommerce Channels', 'Supplier Speed Advantage', 'Low Overhead Structure', 'Scalable Remote Teams', 'AI-Enhanced Operations'].map((adv, i) => <StaggerItem key={i} data-id="element-290">
          <div className="flex items-center gap-4 p-6 border-2 border-black bg-white hover:bg-black hover:text-white transition-colors duration-300 group" data-id="element-291">
            <Check className="w-6 h-6 text-black group-hover:text-white shrink-0" strokeWidth={3} data-id="element-292" />
            <span className="font-bold text-lg uppercase tracking-wide" data-id="element-293">
              {adv}
            </span>
          </div>
        </StaggerItem>)}
    </StaggerContainer>
  </Slide>;
export const Slide10TeamStructure = () => <Slide id="slide-10" bg="gray" data-id="element-294">
    <SlideHeading tag="Global Team Structure" title="Optimized for Scale" subtitle="High quality and low overhead through strategic geographic placement." data-id="element-295" />

    <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-296">
      <StaggerItem data-id="element-297">
        <Card className="h-full p-6 border-t-8 border-t-black" data-id="element-298">
          <h3 className="text-3xl font-serif font-bold text-black uppercase mb-1" data-id="element-299">
            USA
          </h3>
          <p className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-300">
            San Diego HQ
          </p>
          <ul className="space-y-3 text-slate-700 font-medium text-base" data-id="element-301">
            <li className="flex gap-3" data-id="element-302">
              <span className="text-black font-bold" data-id="element-303">+</span> Core Leadership
            </li>
            <li className="flex gap-3" data-id="element-304">
              <span className="text-black font-bold" data-id="element-305">+</span> Production
              Management
            </li>
            <li className="flex gap-3" data-id="element-306">
              <span className="text-black font-bold" data-id="element-307">+</span> Operations
              Strategy
            </li>
            <li className="flex gap-3" data-id="element-308">
              <span className="text-black font-bold" data-id="element-309">+</span> Quality Control
            </li>
            <li className="flex gap-3" data-id="element-310">
              <span className="text-black font-bold" data-id="element-311">+</span> B2B Sales &
              Fulfillment
            </li>
          </ul>
        </Card>
      </StaggerItem>

      <StaggerItem data-id="element-312">
        <Card className="h-full p-6 border-t-8 border-t-slate-400" data-id="element-313">
          <h3 className="text-3xl font-serif font-bold text-black uppercase mb-1" data-id="element-314">
            Mexico
          </h3>
          <p className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-315">
            Creative & Sourcing
          </p>
          <ul className="space-y-3 text-slate-700 font-medium text-base" data-id="element-316">
            <li className="flex gap-3" data-id="element-317">
              <span className="text-black font-bold" data-id="element-318">+</span> Design Production
            </li>
            <li className="flex gap-3" data-id="element-319">
              <span className="text-black font-bold" data-id="element-320">+</span> Color Separations
            </li>
            <li className="flex gap-3" data-id="element-321">
              <span className="text-black font-bold" data-id="element-322">+</span> Sourcing Support
            </li>
            <li className="flex gap-3" data-id="element-323">
              <span className="text-black font-bold" data-id="element-324">+</span> Production Art
            </li>
            <li className="flex gap-3" data-id="element-325">
              <span className="text-black font-bold" data-id="element-326">+</span> Vendor
              Coordination
            </li>
            <li className="flex gap-3" data-id="element-327">
              <span className="text-black font-bold" data-id="element-328">+</span> Overflow Creative
            </li>
          </ul>
        </Card>
      </StaggerItem>

      <StaggerItem data-id="element-329">
        <Card className="h-full p-6 border-t-8 border-t-slate-200" data-id="element-330">
          <h3 className="text-3xl font-serif font-bold text-black uppercase mb-1" data-id="element-331">
            Colombia
          </h3>
          <p className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-332">
            Marketing & Support
          </p>
          <ul className="space-y-3 text-slate-700 font-medium text-base" data-id="element-333">
            <li className="flex gap-3" data-id="element-334">
              <span className="text-black font-bold" data-id="element-335">+</span> Advertising
              Creatives
            </li>
            <li className="flex gap-3" data-id="element-336">
              <span className="text-black font-bold" data-id="element-337">+</span> Social Media
              Support
            </li>
            <li className="flex gap-3" data-id="element-338">
              <span className="text-black font-bold" data-id="element-339">+</span> Ecommerce Listings
            </li>
            <li className="flex gap-3" data-id="element-340">
              <span className="text-black font-bold" data-id="element-341">+</span> Customer Support
            </li>
            <li className="flex gap-3" data-id="element-342">
              <span className="text-black font-bold" data-id="element-343">+</span> Product Uploads
            </li>
            <li className="flex gap-3" data-id="element-344">
              <span className="text-black font-bold" data-id="element-345">+</span> Marketing
              Execution
            </li>
          </ul>
        </Card>
      </StaggerItem>
    </StaggerContainer>
  </Slide>;